<template>
	<v-app :style="cssVars">
		<component v-if="!!layout" :is="layout" component="">
			<router-view></router-view>
		</component>
		<div v-else>Loading...</div>
	</v-app>
</template>

<script>
import GuestLayout from './components/Layouts/GuestLayout'
import AppLayout from './components/Layouts/AppLayout'
import { uuid } from 'vue-uuid'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'App',
	components: {
		GuestLayout,
		AppLayout,
	},
	computed: {
		...mapGetters('settings', ['web', 'ci_cd', 'styles']),

		layout() {
			const layout = [...this.$route.matched]
				.filter((route) => route.meta.layout)
				.map((route) => route.meta.layout)
				.reverse()
				.shift()
			return layout ? `${layout}-layout` : 'guest-layout'
		},
		cssVars() {
			const {
				navigation_bar_tint: navigationBarTint,
				button_secondary_background: buttonSecondaryBgc,
				button_secondary: buttonSecondaryText,
				button_login_background: button_login_background,
				button_login: button_login,
				button_main_background: buttonMainBgc,
				button_main: buttonMainText,
				chip_text_normal: chipTextNormal,
				chip_text_selected: chipTextSelected,
				chips_normal_background: chipNormalBackground,
				chips_selected_background: chipSelectedBackground,
				badge_pin_background: badgePinBackground,
				badge_sponsored_background: badgeSponsoredBackground,
				username_category_title: usernameCategoryTitle,
				company_position_large: companyPositionLarge,
				location: locationColor,
				cell_detail_text: cellDetailText,
			} = this.styles || {}

			let prepareMainBgcButton = buttonMainBgc

			if (buttonMainBgc === buttonSecondaryBgc) {
				prepareMainBgcButton = navigationBarTint
			}

			return {
				'--accent-color': navigationBarTint,

				'--button-login-background': button_login_background,
				'--button-login': button_login,

				'--button-main-background-color': prepareMainBgcButton,
				'--button-main-color': buttonMainText,

				'--button-secondary-background-color': buttonSecondaryBgc,
				'--button-secondary-color': buttonSecondaryText,

				'--chip-text-normal': chipTextNormal,
				'--chip-text-selected': chipTextSelected,
				'--chip-normal-background': chipNormalBackground,
				'--chip-selected-background': chipSelectedBackground,

				'--badge-pin-background': badgePinBackground,
				'--badge-sponsored-background': badgeSponsoredBackground,
				'--username-category-title': usernameCategoryTitle,
				'--company-position-large': companyPositionLarge,
				'--location-color': locationColor,
				'--ceil-detail-text-color': cellDetailText,
			}
		},
	},
	watch: {
		web() {
			const { favicon_image: favicon } = this.web
			this.updateFavicon(favicon)
		},
		ci_cd() {
			const { device_name: cloneTitle } = this.ci_cd
			this.changeTitle(cloneTitle)
		},
	},
	created() {
		// test
		this.setSessionId(uuid.v4())
	},
	methods: {
		...mapActions('app', ['setSessionId']),

		changeTitle(title) {
			document.title = title
		},

		updateFavicon(newFavicon) {
			this.favicon = newFavicon

			const faviconLink = document.querySelector("link[rel='icon']")

			if (faviconLink) {
				faviconLink.href = newFavicon
			}
		},
	},
}
</script>

<style lang="scss">
.page {
	margin-bottom: 10px;

	@media (max-width: 919px) {
		padding-top: 4px;
	}
}
</style>
